export default __webpack_public_path__ + "static/media/recbg.760a0a71.png";